import { createActions } from "redux-actions";

export const {
  getNightPlacementList,
  setNightPlacementList,
  addPlacementToList,
  addPlacementToListSuccess,
  addPlacementToListFailure,
  deletePlacement,
  deletePlacementSuccess,
  deletePlacementFailure,
  editPlacement,
  editPlacementSuccess,
  editPlacementFailure
} = createActions(
  {
    GET_NIGHT_PLACEMENT_LIST: (orderId, pagination, sort) => ({
      orderId,
      pagination,
      sort
    }),
    SET_NIGHT_PLACEMENT_LIST: placements => ({ placements })
  },
  "ADD_PLACEMENT_TO_LIST",
  "ADD_PLACEMENT_TO_LIST_SUCCESS",
  "ADD_PLACEMENT_TO_LIST_FAILURE",
  "DELETE_PLACEMENT",
  "DELETE_PLACEMENT_SUCCESS",
  "DELETE_PLACEMENT_FAILURE",
  "EDIT_PLACEMENT",
  "EDIT_PLACEMENT_SUCCESS",
  "EDIT_PLACEMENT_FAILURE"
);
